import { combineReducers, configureStore } from '@reduxjs/toolkit';
import collisionReducer from './slices/collisionSlice';
import notificationsReducer, {
  initialState as notificationsInitialState,
} from './slices/notificationSlice';
import configurationReducer from './slices/configurationSlice';
import authReducer, {
  initialState as authInitialState,
} from './slices/authSlice';
import spinnerReducer, {
  initialState as spinnerInitialState,
} from './slices/spinnerSlice';
import agreementsReducer from './slices/agreementSlice';
import mediaReducer, {
  initialState as mediaInitialState,
} from './slices/mediaSlice';
import lawEnforcementConfigReducer from './slices/lawEnforcementConfigSlice';
import lawEnforcementCollisionsReducer from './slices/lawEnforcementCollisionsSlice';
import lawEnforcementLEOfficersReducer from './slices/lawEnforcementOfficersSlice';

const saveState = (state: {}) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('reduxState', serializedState);
  } catch (err) {
    console.error('Could not save state', err);
  }
};

const loadState = () => {
  try {
    const serializedState = localStorage.getItem('reduxState');
    if (serializedState === null) {
      return undefined; // No state in storage
    }
    const state = JSON.parse(serializedState);

    state.notifications = notificationsInitialState;
    state.auth = authInitialState;
    state.media = mediaInitialState;

    return state;
  } catch (err) {
    console.error('Could not load state', err);
    return undefined;
  }
};

const persistedState = loadState();

const rootReducer = combineReducers({
  collision: collisionReducer,
  notifications: notificationsReducer,
  configuration: configurationReducer,
  auth: authReducer,
  agreements: agreementsReducer,
  spinner: spinnerReducer,
  media: mediaReducer,
  userAgreements: agreementsReducer,
  lawEnfocementConfiguration: lawEnforcementConfigReducer,
  lawEnforcementCollisions: lawEnforcementCollisionsReducer,
  lawEnforcementLEOfficers: lawEnforcementLEOfficersReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedState, // Initialize with persisted state if available
});

store.subscribe(() => {
  saveState(store.getState());
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
